module.exports = __webpack_public_path__ + "img/samil_thumbnail.15111651.png";